export default __webpack_public_path__ + "static/media/signal-2.1f6ab3b1.svg";